import axios from 'axios';
import { useState } from 'react';
import Swal from 'sweetalert2';

const ResetTwoFaSetup = (props: any) => {
    const [email, setEmail] = useState('');
    const [isEmailValid, setisEmailValid] = useState(false);
    
    const sendEmailToUser = async (event: React.MouseEvent<HTMLButtonElement>) => {
        event.preventDefault();
        const schoolDomain = JSON.parse(localStorage.getItem('school_settings') as any)?.domain;
        console.log('schoolDomain:', schoolDomain);
        const sendForgotPAssLink = `${process.env.REACT_APP_COMMON_API}/email/send-reset-2fa-email`;
        axios
            .post(sendForgotPAssLink, {
                email: email,
                schoolDomain: schoolDomain,
            })
            .then((res: any) => {
                Swal.fire({
                    icon: res.data.success ? 'success' : 'error',
                    title: res.data.success ?'Success':'Error',
                    text: `${res.data.message}`,
                }).then(() => {
                    if (res.data.success) {
                        // retiurn to logiin screen
                        window.location.reload();
                    }
                });
            });
    };

    const handleCheckEmailValid = async(value:string) => {
        setEmail(value);
        const validRegex = /^([A-Za-z0-9_.+-])+@([A-Za-z0-9_.-])+\.([A-Za-z]{2,4})$/;

        if (validRegex.test(value) == false) {
            setisEmailValid(false);
            return;
        }

        setisEmailValid(true);
    }

    return (
        <>
            <div className="form-group">
                <div className="mb-3">
                <h2 className="font-22 text-white text-center">Reset Two Factor Authentication</h2>
            </div>
                <input
                    type="email"
                    className="form-control email"
                    id="Email"
                    name="Email"
                    placeholder="Email *"
                    aria-describedby="emailHelp"
                    onChange={(e) => handleCheckEmailValid(e.target.value)}
                />
                {!isEmailValid && <div className="error-message">Enter valid email address</div>}
                <div className="form_submissions action_btns my-4">
                    <button onClick={(e) => isEmailValid ? sendEmailToUser(e) : ''} className="secondary_btn forgotSubmit btn-login py-2 border-0">
                        Submit
                    </button>
                </div>
            </div>
        </>
    );
};

export default ResetTwoFaSetup;
